import { SubTaskAction, SubTaskActionType } from "data/types";
import { dataDispatcher, updateList } from "./parcels";

export const subtaskReducer = (state: any, action: SubTaskAction): any => {
  if (!Array.isArray(action.data)) return state;
  switch (action.type) {
    case SubTaskActionType.FetchSubtask:
      state.subtasks[action.statusKey] = [];
      return {
        ...state,
        subtasks: {
          ...state.subtasks,
          [action.statusKey]: updateList(state.subtasks[action.statusKey], action.data),
        },
      };
    case SubTaskActionType.UpdateSubTask:
      return {
        ...state,
        subtasks: dataDispatcher(state.subtasks, action.data, "subtask_status"),
      };
    default:
      return state;
  }
};
